<template>
    <gj-modal
            v-bind="$options.$attrs"
            v-on="$options.$listeners"
            :visible.sync="visible"
            no-padding
            :confirm-loading="confirmLoading"
            :modal-append-to-body="false"
            @cancel="cancel"
            @confirm="confirm"
            @opened="opened"
    >
        <div slot="content">
            <component
                    ref="componentInstance"
                    :is="renderComponent"
                    v-bind="renderProps"
                    v-on="renderListener"
                    :style="componentOptions.style"
                    :class="componentOptions.classes"
            >
            </component>
        </div>
    </gj-modal>
</template>

<script>
    export default {
        name: "gj-dialog",
        props: {
            componentOptions: {
                type: Object,
                default() {
                    return {
                        componentConstructor: null,
                        propsData: {},
                        listeners: {},
                        style: {},
                        classes: {}
                    }
                }
            }
        },
        data () {
            return {
                visible: false,
                confirmLoading: false
            }
        },
        computed: {
            renderComponent ({ componentOptions }) {
                return componentOptions.componentConstructor
            },
            renderProps ({ componentOptions }) {
                return componentOptions.propsData
            },
            renderListener ({ componentOptions }) {
                return componentOptions.listeners
            }
        },
        methods: {
            close () {
                this.visible = false
            },
            open () {
                this.visible = true
                this.$emit('open')
            },
            opened () {
                this.$emit('opened')
            },
            cancel () {
                this.close()
                this.$refs.componentInstance && this.$refs.componentInstance.cancel && this.$refs.componentInstance.cancel()
            },
            confirm () {
                this.$refs.componentInstance && this.$refs.componentInstance.confirm && this.$refs.componentInstance.confirm()
            }
        }
    }
</script>

<style scoped>

</style>
